import classnames from 'classnames';
import React from 'react';
import { Tag } from '@meitu/saas-ui';
import { ImagePanelFeatureType } from '@/types';
import './style.less';

const { CheckableTag } = Tag;

const TagList: React.FC<{
    cardTypeList: ImagePanelFeatureType[];
    cardTagList?: string[]; // 需要与 cardTypeList 一一对应
    curType: ImagePanelFeatureType | '';
    setCurType: (type: ImagePanelFeatureType | '') => void;
}> = ({ curType, cardTagList, cardTypeList, setCurType }) => {
    return cardTagList?.length ? (
        <div className="b-list-menu__tag-list">
            {cardTagList?.map((tag, index) => (
                <CheckableTag
                    key={index}
                    checked={curType === cardTypeList[index]}
                    className={classnames('b-list-menu__tag', {
                        active: curType === cardTypeList[index],
                    })}
                    onClick={(e) => {
                        console.log({
                            curType,
                            index,
                            target: cardTypeList[index],
                        });
                        e.stopPropagation();
                        setCurType(cardTypeList[index]);
                    }}
                >
                    {tag}
                </CheckableTag>
            ))}
        </div>
    ) : null;
};

export default React.memo(TagList);
